module.exports = __webpack_public_path__ + "img/logo_ar.31a5571.png";